import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-build",
  "use": "icon-build-usage",
  "viewBox": "0 0 19.55 19.549",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19.55 19.549\" id=\"icon-build\"><g transform=\"translate(-2963.454 1882.451)\"><path d=\"M2976.894-1881.229l-6.109,6.109h-3.665l-3.666,4.887s3.884-1.081,6.149-.574l-6.149,7.905,8.054-6.265c1.124,2.571-.723,6.265-.723,6.265l4.888-3.665v-3.666l6.109-6.109,1.222-6.109Z\" fill=\"#fff\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol